import {
  adjustedcowFeed,
  cowFeed,
  manureManager,
  watercredit,
} from './items.js'

const inventory = [
  adjustedcowFeed,
  cowFeed,
  watercredit,
  manureManager,
]

export default inventory
